import React from 'react';

type ButtonVariant = 'primary' | 'ghost';

interface ButtonProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  variant?: ButtonVariant;
  href: string;
  children: React.ReactNode;
  onClick?: React.MouseEventHandler<HTMLAnchorElement>;
}

/**
 * Polymorphic anchor-based button.
 * Use `variant="primary"` for filled CTA, `variant="ghost"` for outlined.
 */
export const Button: React.FC<ButtonProps> = ({
  variant = 'primary',
  href,
  children,
  onClick,
  ...rest
}) => (
  <a
    href={href}
    className={variant === 'primary' ? 'btn-primary' : 'btn-ghost'}
    onClick={onClick}
    {...rest}
  >
    {children}
  </a>
);
